import eventbus from 'tiny-emitter/instance';
import reject from 'lodash/reject';
import { SEATSTATUS, MODE } from '@/constants';
import store from '@/store/store';

export default class SelectionBox {
  constructor(app) {
    this.app = app;
    this.setup();
    this.addEventListeners();
  }

  setup() {
    this.initSelectionBox();
  }

  initSelectionBox() {
    this.nested = this.app.svg.nested().viewbox(0, 0, 1920, 609);
    this.selectionRect = this.nested.rect(0, 0).addClass('selection-box-rect');
    this.selectionBox = this.nested.group().addClass('selection-box');
    this.selectionBox.add(this.selectionRect);
    this.selectionBox.hide();
  }

  addEventListeners() {
    eventbus.on('selection:updated', this.handleSelectionUpdate, this);
    eventbus.on('camera:zoomed', this.updateSelectionBox, this);
    eventbus.on('camera:panned', this.updateSelectionBox, this);
    eventbus.on('seatmap:changemode', this.updateSelectionBox, this);
    eventbus.on('seatmap:updateSelectionBox', this.updateSelectionBox, this);
    eventbus.on('selectionbox:hide', this.selectionBoxHide, this);
    eventbus.on('selectionbox:show', this.selectionBoxShow, this);
  }

  removeEventListeners() {
    eventbus.off('selection:updated', this.handleSelectionUpdate);
    eventbus.off('camera:zoomed', this.updateSelectionBox);
    eventbus.off('camera:panned', this.updateSelectionBox);
    eventbus.off('seatmap:changemode', this.updateSelectionBox);
    eventbus.off('seatmap:updateSelectionBox', this.updateSelectionBox);
    eventbus.off('selectionbox:hide', this.selectionBoxHide, this);
    eventbus.off('selectionbox:show', this.selectionBoxShow, this);
  }

  selectionBoxShow() {
    this.selectionBox.show();
    this.selectionBox.front();
  }

  selectionBoxHide() {
    this.selectionBox.back();
    this.selectionBox.hide();
  }

  updateSelectionBox() {
    if (store.state.settings.mode !== MODE.DRAWING) {
      this.app.seatmap.selection.items = reject(
        this.app.seatmap.selection.items,
        (u) =>
          u.attributes.status === SEATSTATUS.OCCUPIED ||
          u.attributes.status === SEATSTATUS.RESERVED ||
          u.attributes.status === SEATSTATUS.CART
      );
    }
    this.handleSelectionUpdate(this.app.seatmap.selection);
  }

  handleSelectionUpdate(selection) {
    const ifHotkeyPressed = this.app.hotKeyPressed && this.app.commandKeyPressed;
    if (selection.items.length > 0 || ifHotkeyPressed) {
      this.updateView(selection.rbox(this.nested));
      this.app.seatmap.oldSelectionBox = selection.rbox();
      this.selectionBox.front();
      this.selectionBox.show();
    } else {
      this.app.seatmap.oldSelectionBox = null;
      this.selectionBox.hide();
    }

    if (
      this.app.seatmap.store.splitModeUnit &&
      this.app.seatmap.selection.items.length === 1 &&
      this.app.seatmap.selection.items[0].uuid === this.app.seatmap.store.splitModeUnit
    ) {
      this.selectionBox.addClass('unclickable');
    } else {
      this.selectionBox.removeClass('unclickable');
    }
  }

  updateView(bbox) {
    this.selectionRect.size(bbox.width, bbox.height).move(bbox.x, bbox.y);
    this.selectionBox.untransform();
  }

  destroySelectionBox() {
    this.selectionBox.remove();
    this.nested.remove();
  }

  destroy() {
    this.removeEventListeners();
    this.destroySelectionBox();
  }
}
